// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px;
  background-color: #390879;
}

.footer-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  font-family: "Alegreya Sans SC", sans-serif;
  width: 100%;
}

.footer-name {
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  font-size: 25px;
  border-bottom: 1px solid white;
  margin-top: 40px;
}

@media screen and (max-width: 1680px) {
  .footer-name {
    font-size: 20px;
  }
}
.powered-by-name {
  font-family: "Spartan", sans-serif;
  color: darkgray;
  font-size: 10px;
  margin-top: 10px;
}

@media screen and (max-width: 1680px) {
  .powered-by-name {
    font-size: 10px;
  }
}
.footer-icon {
  margin: 5px;
}

.left-links {
  border-top: 2px solid #a5e300;
  display: flex;
  flex-direction: column;
  color: white;
}

.left-links > a {
  margin: 10px;
  color: white;
  font-size: 20px;
  text-decoration: none;
}

@media screen and (max-width: 1680px) {
  .left-links > a {
    font-size: 15px;
  }
}
@media (max-width: 500px) {
  .left-links > a {
    font-size: 0.9rem;
  }
}
.left-links > a:hover {
  color: #a5e300;
}

.middle-links {
  border-top: 2px solid #337def;
  display: flex;
  flex-direction: column;
  color: white;
}

.middle-links > a {
  margin: 10px;
  color: white;
  font-size: 20px;
  text-decoration: none;
}

@media screen and (max-width: 1680px) {
  .middle-links > a {
    font-size: 15px;
  }
}
@media (max-width: 500px) {
  .middle-links > a {
    font-size: 0.9rem;
  }
}
.middle-links > a:hover {
  color: #a5e300;
}

.right-links {
  border-top: 2px solid #00ffff;
  display: flex;
  flex-direction: column;
  color: white;
}

.right-links > a {
  margin: 10px;
  color: white;
  font-size: 20px;
  text-decoration: none;
}

@media screen and (max-width: 1680px) {
  .right-links > a {
    font-size: 15px;
  }
}
@media (max-width: 500px) {
  .right-links > a {
    font-size: 0.9rem;
  }
}
.right-links > a:hover {
  color: #a5e300;
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,2CAAA;EACA,WAAA;AACF;;AAEA;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,eAAA;EACF;AACF;AAEA;EACE,kCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE;IACE,eAAA;EAAF;AACF;AAGA;EACE,WAAA;AADF;;AAIA;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AADF;;AAIA;EACE;IACE,eAAA;EADF;AACF;AAIA;EACE;IACE,iBAAA;EAFF;AACF;AAKA;EACE,cAAA;AAHF;;AAMA;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAHF;;AAMA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AAHF;;AAMA;EACE;IACE,eAAA;EAHF;AACF;AAMA;EACE;IACE,iBAAA;EAJF;AACF;AAOA;EACE,cAAA;AALF;;AAQA;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AALF;;AAQA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;AALF;;AAQA;EACE;IACE,eAAA;EALF;AACF;AAQA;EACE;IACE,iBAAA;EANF;AACF;AASA;EACE,cAAA;AAPF","sourcesContent":[".footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 50px;\n  background-color: #390879;\n}\n\n.footer-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  font-family: \"Alegreya Sans SC\", sans-serif;\n  width: 100%;\n}\n\n.footer-name {\n  font-family: \"Spartan\", sans-serif;\n  color: #a5e300;\n  font-size: 25px;\n  border-bottom: 1px solid white;\n  margin-top: 40px;\n}\n\n@media screen and (max-width: 1680px) {\n  .footer-name {\n    font-size: 20px;\n  }\n}\n\n.powered-by-name {\n  font-family: \"Spartan\", sans-serif;\n  color: darkgray;\n  font-size: 10px;\n  margin-top: 10px;\n}\n\n@media screen and (max-width: 1680px) {\n  .powered-by-name {\n    font-size: 10px;\n  }\n}\n\n.footer-icon {\n  margin: 5px;\n}\n\n.left-links {\n  border-top: 2px solid #a5e300;\n  display: flex;\n  flex-direction: column;\n  color: white;\n}\n\n.left-links > a {\n  margin: 10px;\n  color: white;\n  font-size: 20px;\n  text-decoration: none;\n}\n\n@media screen and (max-width: 1680px) {\n  .left-links > a {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 500px) {\n  .left-links > a {\n    font-size: 0.9rem;\n  }\n}\n\n.left-links > a:hover {\n  color: #a5e300;\n}\n\n.middle-links {\n  border-top: 2px solid #337def;\n  display: flex;\n  flex-direction: column;\n  color: white;\n}\n\n.middle-links > a {\n  margin: 10px;\n  color: white;\n  font-size: 20px;\n  text-decoration: none;\n}\n\n@media screen and (max-width: 1680px) {\n  .middle-links > a {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 500px) {\n  .middle-links > a {\n    font-size: 0.9rem;\n  }\n}\n\n.middle-links > a:hover {\n  color: #a5e300;\n}\n\n.right-links {\n  border-top: 2px solid #00ffff;\n  display: flex;\n  flex-direction: column;\n  color: white;\n}\n\n.right-links > a {\n  margin: 10px;\n  color: white;\n  font-size: 20px;\n  text-decoration: none;\n}\n\n@media screen and (max-width: 1680px) {\n  .right-links > a {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 500px) {\n  .right-links > a {\n    font-size: 0.9rem;\n  }\n}\n\n.right-links > a:hover {\n  color: #a5e300;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
